import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Play, Award, Users, Globe } from 'lucide-react';

const AcademyIntroSection = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      badge: "About Us",
      title: "Welcome to Canada English Life Academy",
      subtitle: "Your Journey to English Excellence Starts Here",
      description: "Discover why thousands of students choose us as their trusted partner in learning English. Watch our story and see how we've been transforming lives since 2017.",
      watchVideo: "Watch Our Story",
      stats: [
        { icon: Users, value: "5,000+", label: "Happy Students" },
        { icon: Award, value: "8+", label: "Years Experience" },
        { icon: Globe, value: "15+", label: "Countries Served" }
      ]
    },
    ar: {
      badge: "من نحن",
      title: "مرحباً بكم في أكاديمية كندا للحياة الإنجليزية",
      subtitle: "رحلتك إلى التميز في اللغة الإنجليزية تبدأ هنا",
      description: "اكتشف لماذا يختارنا الآلاف من الطلاب كشريك موثوق في تعلم اللغة الإنجليزية. شاهد قصتنا وكيف نغير الحياة منذ عام 2017.",
      watchVideo: "شاهد قصتنا",
      stats: [
        { icon: Users, value: "5,000+", label: "طالب سعيد" },
        { icon: Award, value: "8+", label: "سنوات خبرة" },
        { icon: Globe, value: "15+", label: "دولة نخدمها" }
      ]
    }
  };

  const t = content[language];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-block">
              <span className="px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold">
                {t.badge}
              </span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              {t.title}
            </h2>

            <p className="text-xl text-teal-600 font-semibold">
              {t.subtitle}
            </p>

            <p className="text-lg text-gray-600 leading-relaxed">
              {t.description}
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-3 gap-6 pt-6">
              {t.stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <stat.icon className="w-6 h-6 text-teal-600" />
                  </div>
                  <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                  <p className="text-sm text-gray-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right Video */}
          <div className="relative group">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              {/* Video Container */}
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/TfYTTNG2qBo"
                  title="Canada English Life Academy Introduction"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-teal-500 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-emerald-500 rounded-full opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AcademyIntroSection;
